var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwapIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 16.125H6C5.379 16.125 4.875 16.629 4.875 17.25C4.875 17.871 5.379 18.375 6 18.375H21C21.621 18.375 22.125 17.871 22.125 17.25C22.125 16.629 21.621 16.125 21 16.125Z",
    fill: "#03F5AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7.875H18C18.621 7.875 19.125 7.371 19.125 6.75C19.125 6.129 18.621 5.625 18 5.625H3C2.379 5.625 1.875 6.129 1.875 6.75C1.875 7.371 2.379 7.875 3 7.875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4546 14.295L19.4081 17.25L16.4546 20.205C16.0151 20.643 16.0151 21.357 16.4546 21.795C16.8926 22.2345 17.6066 22.2345 18.0446 21.795L21.7946 18.045C22.2341 17.6055 22.2341 16.8945 21.7946 16.455L18.0446 12.705C17.6066 12.2655 16.8926 12.2655 16.4546 12.705C16.0151 13.143 16.0151 13.857 16.4546 14.295Z",
    fill: "#03F5AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54463 9.70499L4.59113 6.74999L7.54463 3.79499C7.98413 3.35699 7.98413 2.64299 7.54463 2.20499C7.10663 1.76549 6.39262 1.76549 5.95463 2.20499L2.20463 5.95499C1.76513 6.39449 1.76513 7.10549 2.20463 7.54499L5.95463 11.295C6.39262 11.7345 7.10663 11.7345 7.54463 11.295C7.98413 10.857 7.98413 10.143 7.54463 9.70499Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIc);
export default __webpack_public_path__ + "static/media/swap_ic.68a995d4ecdcb19c68d4b2b3892c1ecf.svg";
export { ForwardRef as ReactComponent };